import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const AIAgentsListPage = () => import('./AIAgentsListPage.vue');
const AIAgentBuilderPage = () => import('./AIAgentBuilderPage.vue');
const Index = () => import('./index.vue');
export default {
 routes : [
  {
    path: frontendURL('accounts/:accountId/ai-agents'),
    component: SettingsContent,
    props: {
      headerTitle: 'AI_AGENTS_PAGE.LIST.HEADER',
      icon: 'arrow-swap',
    },


    children: [


      {
        path: '',
        redirect: "all"
      },

      {
        path: 'all',
        name: 'ai-agents_all',
        roles: ['administrator'],
        component: Index,
        props: { status: -1 }
      },
      {
        path: 'new',
        name: 'ai_agent_new',
        roles: ['administrator'],
        component: AIAgentBuilderPage,
      },
      {
        path: ':id',
        name: 'ai_agent_edit',
        roles: ['administrator'],
        component: AIAgentBuilderPage,
      },

    ]
  }

/*
  
  {
    path: frontendURL('accounts/:accountId/ai-agents'),
    name: 'ai_agents_list',
    roles: ['administrator'],
    component: AIAgentsListPage,
    props: {
      headerTitle: 'AI_AGENTS_PAGE.LIST.HEADER',
      icon: 'arrow-swap',
    },
   

      {
        path: frontendURL('accounts/:accountId/ai-agents/new'),
        name: 'ai_agent_new',
        roles: ['administrator'],
        component: AIAgentBuilderPage,
      },
      {
        path: frontendURL('accounts/:accountId/ai-agents/:agentId/edit'),
        name: 'ai_agent_edit',
        roles: ['administrator'],
        component: AIAgentBuilderPage,
      },

    
  },*/
  
]
} 

